module.exports = __webpack_public_path__ + "static/media/feishu_calendar.3218b86b.png";